import React from 'react';
import PropTypes from 'prop-types';
import styles from './TeamComponent.module.css';
import '../styles/theme.css';

function TeamComponent({ members }) {
  return (
    <section id="team" className={styles['team']}>
      <div className={styles['team-inner']}>
        <div aria-hidden="true" className={styles['quote-glyph']}>“</div>
        <div className={styles['team-head']}>
          <div className={styles['eyebrow']}>Our Core Team</div>
          <div className={styles['rule']} aria-hidden="true" />
        </div>
        <div className={styles['team-grid']}>
          {members.map((m, i) => (
            <article key={i} className={styles['member']}>
              <div className={styles['photo-frame']}>
                <img
                  src={m.photoUrl}
                  alt={m.name}
                  className={styles['photo']}
                  style={(() => {
                    const t = [];
                    if (m.zoom) t.push(`scale(${m.zoom})`);
                    if (m.offsetY) t.push(`translateY(${m.offsetY}px)`);
                    return t.length ? { transform: t.join(' ') } : undefined;
                  })()}
                />
              </div>
              <div className={styles['member-info']}>
                <div className={styles['name']}>{m.name}</div>
                <div className={styles['role']}>{m.position}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

TeamComponent.propTypes = {
  members: PropTypes.arrayOf(
    PropTypes.shape({
      photoUrl: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      position: PropTypes.string.isRequired,
      zoom: PropTypes.number,
      offsetY: PropTypes.number,
    })
  ).isRequired,
};

export default TeamComponent;
